import React from "react";
import { Shield, BadgeCheck, Undo2, FileCheck } from "lucide-react";
import { Badge } from "./ui/badge";
import { useTranslation } from "react-i18next";

export const GuaranteeSection = () => {
  const { t } = useTranslation();
  return (
    <section className="py-20 lg:py-28 bg-white" id="garantia">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="relative section-reveal">
            {/* Background glow */}
            <div className="absolute -inset-4 bg-gradient-to-r from-[#0C2340]/5 via-[#C8A24D]/10 to-[#0C2340]/5 rounded-[36px] blur-2xl" />
            
            <div className="relative bg-gradient-to-br from-[#0C2340] to-[#1B3A5C] rounded-3xl overflow-hidden">
              {/* Decorative patterns */}
              <div className="absolute inset-0 opacity-5">
                <div className="absolute top-8 right-8 w-40 h-40 border-2 border-white rounded-full" />
                <div className="absolute top-12 right-12 w-32 h-32 border border-white rounded-full" />
                <div className="absolute bottom-8 left-8 w-24 h-24 border border-white rounded-full" />
              </div>

              <div className="relative z-10 p-8 sm:p-12 lg:p-16">
                <div className="flex flex-col lg:flex-row gap-10 items-start">
                  {/* Left - Icon and Title */}
                  <div className="lg:w-2/5 shrink-0">
                    <div className="w-16 h-16 rounded-2xl bg-[#C8A24D]/20 flex items-center justify-center mb-6 animate-pulse-gold">
                      <Shield className="w-8 h-8 text-[#E8D5A0]" />
                    </div>
                    <Badge className="bg-white/10 text-[#E8D5A0] border-[#C8A24D]/30 hover:bg-white/15 mb-4 py-1.5 px-4 text-xs font-semibold tracking-wide uppercase">
                      {t("guarantee.badge")}
                    </Badge>
                    <h2 className="text-3xl sm:text-4xl text-white leading-tight" style={{ fontFamily: "'DM Serif Display', serif" }}>
                      {t("guarantee.title")}
                    </h2>
                  </div>

                  {/* Right - Content */}
                  <div className="lg:w-3/5">
                    <p className="text-white/80 text-lg leading-relaxed mb-8">
                      {t("guarantee.body")} <span className="text-[#E8D5A0] font-semibold">{t("guarantee.bodyHighlight")}</span> {t("guarantee.bodySuffix")}
                    </p>

                    <div className="grid sm:grid-cols-3 gap-4">
                      {[
                        { icon: BadgeCheck, label: t("guarantee.tag1") },
                        { icon: Undo2, label: t("guarantee.tag2") },
                        { icon: FileCheck, label: t("guarantee.tag3") },
                      ].map((item, id) => (
                        <div key={id} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 text-center hover:bg-white/10 transition-colors duration-300">
                          <item.icon className="w-6 h-6 text-[#C8A24D] mx-auto mb-2" />
                          <p className="text-white/80 text-xs font-medium">{item.label}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuaranteeSection;
